import React from 'react';

export const SSRContext = React.createContext<{
  isUAMobile: boolean;
  isSSR: boolean;
  isRouteSSR: boolean;
}>({ isUAMobile: false, isSSR: false, isRouteSSR: true });

export function useSSRContext() {
  const ctx = React.useContext(SSRContext);
  return ctx;
}
